import React from "react";
import RoleDataContainer from "@commr/admin/components/roles/roleDataContainer";
import { Role } from "@commr/admin/models/role/role";

const AddRolePage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <RoleDataContainer role={new Role()} />
);

export default AddRolePage;
